<template>
    <van-popup
        v-model="popupModel"
        position="bottom"
    >
        <div class="model">
            <div class="model_list">
                <div class="model_list_item model_borderBottom col8E8E93">配送方式</div>
                <div class="model_list_item model_borderBottom" v-for="(item, index) in modelAddress" :key='item.type' @click="onDispatch(index)">{{ item.name }}</div>
            </div>
            <div class="model_list m20">
                <div class="model_list_item colFF7A45" @click="onCancel">取消</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        modelAddress: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupModel: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onCancel () {
            this.$emit('update:visible')
        },
        onDispatch (obj) {
            this.$emit('update:visible')
            this.$emit('payModel', obj)
        }
    }
}
</script>

<style lang="scss" scoped>
.model{
    margin: 0 24px;
    border-radius: 8px;
    background: none;
    &_list{
        border-radius: 8px;
        background: #ffffff;
        &_item{
            padding: 32px;
            font-size: 32px;
            text-align: center;
            position: relative;
            &.borderBot:before{
                width: auto;
                left: 0;
            }
        }
    }
    &_borderBottom {
        position: relative;
        &::before {
            position: absolute;
            content: '';
            bottom: 0;
            right: 0;
            left: 0;
            width: 100%;
            border-bottom: 2px solid rgba(209,209,214,1);
            transform: scaleY(0.5);
            z-index: 8;
        }
    }
}
</style>